<template>
  <v-app-bar class app color="grey lighten-4">
    <v-app-bar-nav-icon @click.prevent="$emit('left-nav-toggle')"></v-app-bar-nav-icon>
    <v-toolbar-title
      v-if="$route.meta.nav.name !== 'Page Not Found'"
      class="text-xs-right"
    >{{$route.meta.nav?$route.meta.nav.name : ''}}</v-toolbar-title>
    <v-spacer></v-spacer>

    <v-toolbar-title class="subheading pr-3" v-if="$route.name === 'Locations'">
      <span class="color--grey">Welcome</span>
      {{vg_user.first_name}}
    </v-toolbar-title>

    <v-menu
      :close-on-content-click="true"
      :nudge-bottom="50"
      :nudge-left="50"
      :nudge-width="100"
      attach
      max-height="400"
      class="top-nav-select-business"
    >
      <template v-slot:activator="{ on }">
        <v-btn outlined color="primary" v-on="on">
          <i class="fas fa-user-circle"></i>
          &nbsp; {{selectedBusiness.name}}
        </v-btn>
      </template>
      <v-card scrollable>
        <v-list>
          <v-list-item @click.prevent.stop="logout">
            <v-list-item-content>
              <v-list-item-title class="ml-4">
                Logout
              <span class="ml-4">
                <v-icon light>exit_to_app</v-icon>
              </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <template v-for="(business, index) in businessList">
            <v-list-item :key="index" ripple @click="switchBusiness(business)">
              <v-list-item-content>
                <v-list-item-title :class="{'accent--text': selectedBusiness.id === business.id}">
                  {{index +1 }}. {{ business.name }}
                  <span
                    v-if="selectedBusiness.id === business.id"
                  >
                    <v-icon color="accent">done</v-icon>
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-divider v-bind:key="`${index}_accounts`" v-if="userAccounts.length > index + 1"></v-divider> -->
          </template>
        </v-list>
      </v-card>
    </v-menu>
    <!-- <v-btn icon @click.stop="$emit('right-nav-toggle')">
      <v-icon>more_vert</v-icon>
    </v-btn>-->
  </v-app-bar>
</template>
<script>
import { mapGetters } from 'vuex'
import AuthApi from '@/controllers/AuthApis'

export default {
  data: () => {
    return {}
  },
  methods: {
    async logout () {
      try {
        await this.$store.dispatch('auth/logout')
        this.$store.commit('CLEAR_STATE')
        localStorage.clear()

        this.snackbar({ text: 'Logout successful' })
        await this.$router.push({ name: 'Login' })
      } catch (e) {
        await this.$store.commit('auth/SET_USER', '')
        this.$store.commit('CLEAR_STATE')
        localStorage.clear()
        this.snackbar({ text: 'Logout successful' })
        await this.$router.push({ name: 'Login' })
      }

      this.$vuetify.theme.themes.light.primary = '#db563f'
      this.$vuetify.theme.themes.light.secondary = '#FAFAFA'
      this.$vuetify.theme.themes.light.accent = '#14B9D6'
    },

    async switchBusiness (business) {
      /*
       * backup user details
       */
      const userDetails = this.$store.getters['auth/user']
      const businessList = this.$store.getters['business/businessList']
      /*
       * clear state and then commit the backed up user and business details
       * to switch the business
       */
      this.$store.commit('CLEAR_STATE')
      this.$store.commit('auth/SET_USER', userDetails)
      this.$store.commit('business/SET_BUSINESS_LIST', businessList)
      this.spinner(true)
      await AuthApi.setActiveBusiness(business.id).then(async res => {
        // when successfully set active business
        if (res) {
          await this.$store.dispatch('business/getBusinessBranding', business.id) // fetch branding
          if (this.$route.path !== '/locations') {
            this.$router.push('/locations')
          }
          try {
            await this.$store.dispatch('locations/GetAllLocations', { page: 1 })
          } catch (e) {
            this.snackbar({ text: e.response.data.msg })
            this.spinner(false)
          }
          // set branding theme
          if (this.branding.brand_colors) {
            this.$vuetify.theme.themes.light.primary = this.branding.brand_colors.primary
            this.$vuetify.theme.themes.light.secondary = this.branding.brand_colors.secondary
            this.$vuetify.theme.themes.light.accent = this.branding.brand_colors.accent
          } else {
            this.$vuetify.theme.themes.light.primary = '#db563f'
            this.$vuetify.theme.themes.light.secondary = '#FAFAFA'
            this.$vuetify.theme.themes.light.accent = '#14B9D6'
          }

          this.spinner(false)

          this.snackbar({ text: 'Account Switched' })
        } else {
          this.snackbar({ text: 'Account Switch failed' })
          this.spinner(false)
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      vg_user: 'auth/user',
      businessList: 'business/businessList',
      selectedBusiness: 'business/selectedBusiness',
      branding: 'business/activeBusinessBranding'
    })
  }
}
</script>
